import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const LadakhPage = () => {
  return <DestinationTemplate destinationId="ladakh" />;
};

export default LadakhPage;
